import React from 'react';
import CopyRight from './CopyRight/CopyRight';
import LangSwitcher from '../../components/MultiLangWrapper/LangSwitcher';

const LayoutOuter = (props) => {
  const { children } = props;

  return (
    <div className="layoutOuter">
      <div className="layoutOuter__switcherPosition">
        <LangSwitcher />
      </div>
      <main className="layoutOuter__content">
        {children}
      </main>
      <CopyRight />
    </div>
  );
};

export default LayoutOuter;
